import { useEffect, useState } from 'react';
import { SearchNavbar, SearchProducts } from '@features/search';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';
import { useSearchParams } from 'react-router-dom';

export const SearchPage = () => {
  const set = useNavbar();
  const [searchParams] = useSearchParams();

  const [query, setQuery] = useState('');

  useEffect(() => {
    set.search();
  }, []);

  const paramsQuery = searchParams.get('query');

  useEffect(() => {
    if (paramsQuery) setQuery(paramsQuery);
  }, [paramsQuery]);

  return (
    <>
      <div className="hidden lg:block container max-w-7xl mx-auto">
        <div className="hidden lg:block mt-12">
          <Breadcrumbs>
            <BreadcrumbItem href="/">
              <Home2 size="24" color="#9CA5AC" />
            </BreadcrumbItem>
            <BreadcrumbItem color="primary">Результаты поиска</BreadcrumbItem>
          </Breadcrumbs>
        </div>

        <div className="mt-6">
          <h1 className="hidden lg:inline text-4xl text-[#222222] font-bold">
            Результаты поиска
          </h1>
        </div>
      </div>

      <div className="h-full container max-w-7xl lg:flex lg:flex-col lg:items-center lg:justify-center lg:mx-auto lg:min-h-[500px] lg:pb-32 lg:mt-12">
        <SearchNavbar onChange={setQuery} />

        <SearchProducts query={query} />
      </div>
    </>
  );
};
